import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import "../../../assests/css/studentdashboard/MyRequest.css";
import { useNavigate } from "react-router-dom";

const MyRequests = ({ onOpenChat }) => {
    const navigate = useNavigate();
    const { baseUrl } = useContext(AppContext);
    const [requests, setRequests] = useState([]);
    const fetchRequests = () => {
    const student = JSON.parse(localStorage.getItem("student"));
    console.log("STUDENT:", student);
    console.log("STUDENT ID:", student?.id);
    axios
        .post(baseUrl + "/student/helpsupport/fetchAllRequest", {
            ngstudent_id: student?.id,
        })
        .then((response) => {

            console.log("REQUEST API RESPONSE:", response.data);
            console.log("REQUESTS:", response.data.requests);

            if (response.data.success) {
                setRequests(response.data.requests);
            }
        })
        .catch((error) => {
            console.log("REQUEST API ERROR:", error);
        });
};
    useEffect(() => {
        fetchRequests();
    }, []);
    const handleOpenChat = (grRequest) => {
        if (grRequest.request_type === "notes_dispute") {
            navigate("/teacher-chat/" + grRequest.conversation_id);
        } else {
            navigate("/chat/" + grRequest.conversation_id);
        }
    };


    return (
         <StudentsideLayout>
        <div className="gr-requests-container">
            <div className="gr-requests-header">
                <h2 className="gr-requests-title">My Requests</h2>
            </div>

            <div className="gr-requests-grid">
                {requests.map((req) => (
                    <div className="gr-request-card" key={req.id}>
                        <div className="gr-request-card-top">
                            <h3 className="gr-request-name">{req.title}</h3>
                            <span
                                className={`gr-status-badge ${req.status === "Pending"
                                    ? "gr-status-pending"
                                    : "gr-status-resolved"
                                    }`}
                            >
                                {req.status}
                            </span>
                        </div>

                        <div className="gr-request-info">
                            <div className="gr-request-info-row">
                                <span className="gr-request-label">Issue:</span>
                                <span className="gr-request-value">{req.issue}</span>
                            </div>
                            <div className="gr-request-info-row">
                                <span className="gr-request-label">Date:</span>
                                <span className="gr-request-value">{req.date}</span>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="gr-open-chat-btn"
                            onClick={() => handleOpenChat(req)}
                        >
                            Open Chat
                        </button>
                    </div>
                ))}
            </div>
        </div>
        </StudentsideLayout>
    );
};

export default MyRequests;